import { render, staticRenderFns } from "./CabinetRows.vue?vue&type=template&id=5d1ebfd2&scoped=true"
import script from "./CabinetRows.vue?vue&type=script&lang=js"
export * from "./CabinetRows.vue?vue&type=script&lang=js"
import style0 from "./CabinetRows.vue?vue&type=style&index=0&id=5d1ebfd2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ebfd2",
  null
  
)

export default component.exports